module.exports = __webpack_public_path__ + "svg/video.svg?ec4ea579d8657f252b8e0931764da45d";